<template lang="pug">
.leftNav
  el-input(v-model="filterTextSys", size="small", placeholder="输入关键字进行过滤", clearable)
  el-tree.filter-tree(
    ref="orgTree",
    :data="orgData",
    :props="defaultProps",
    default-expand-all,
    check-strictly,
    :filter-node-method="filterNode",
    show-checkbox,
    node-key="nodeId",
    @check="checkNodeChange",
    v-slot="{ node, data }"
  )
    node-icon(:node="node", type="Dept") {{ data.deptName }}
</template>

<script>
import { mapState } from "vuex";
import flowService from "@/CommonDP/service/flow-service";
import NodeIcon from "./NodeIcon.vue";

export default {
  components: { NodeIcon },
  props: {
    // 选中的人员组件
    userList: { type: Array, default: () => [] }
  },
  data() {
    return {
      orgData: [], // 部门列表
      filterTextSys: "",
      defaultProps: {
        children: "children",
        label: "deptName"
      },
      nowSelect: []
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId,
      userInfo: (state) => state.user.userInfo
    }),
    defaultCheckedKeys() {
      return this.nowSelect?.map(({ nodeId }) => nodeId) || [];
    }
  },
  watch: {
    filterTextSys(val) {
      this.$refs.orgTree.filter(val);
    },
    userList: {
      immediate: true,
      handler(val) {
        this.nowSelect = val;
        this.$refs.orgTree?.setCheckedKeys(this.defaultCheckedKeys);
      }
    }
  },
  mounted() {
    this.getOrgList();
  },
  methods: {
    // 获取部门列表
    async getOrgList() {
      const res = await flowService.getPersonChooseOrgTree(this.enterpriseId);
      const oldArray = res.data || [];
      const each = (list) => {
        for (const item of list) {
          item.nodeId = item.deptId;
          if (item.children && item.children.length > 0) each(item.children);
          else delete item.children;
        }
      };
      each(oldArray);
      this.orgData = oldArray;
      if (this.nowSelect && this.nowSelect.length > 0) {
        await this.$nextTick();
        this.$refs.orgTree?.setCheckedKeys(this.defaultCheckedKeys);
      }
    },
    // 标签树形结构选择器
    checkNodeChange(data, currentChecked) {
      this.nowSelect = this.$refs.orgTree.getCheckedNodes();
      this.emitList();
    },
    // 给父级抛出选中的人员
    emitList() {
      const list = this.nowSelect.map((e) => {
        return {
          ...e,
          id: e.deptId,
          userId: e.deptId,
          name: e.deptName,
          selectName: e.deptName,
          type: 7
        };
      });
      this.$emit("updateRight", "Dept", list);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.deptName.indexOf(value) !== -1;
    }
  }
};
</script>

<style lang="scss" scoped>
.leftNav{
  height: 100%;
  .filter-tree{
    height: calc(100% - 32px);
    overflow: auto;
  }
}
</style>
